import __relayOperation0 from './ViewerAppsRefetchQuery.graphql'
/**
 * @generated SignedSource<<e383d86bb601cdeb8ed9e23db80e5463>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonalAppsMenuItem_viewer$data = {
  readonly me: {
    readonly apps: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly slug: string;
    }>;
    readonly id: string;
  } | null;
  readonly " $fragmentType": "PersonalAppsMenuItem_viewer";
};
export type PersonalAppsMenuItem_viewer$key = {
  readonly " $data"?: PersonalAppsMenuItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonalAppsMenuItem_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": __relayOperation0
    }
  },
  "name": "PersonalAppsMenuItem_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "App",
          "kind": "LinkedField",
          "name": "apps",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "992c5aeea30d5b9ffb0e0c2d8dd5f117";

export default node;
